import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "44",
      height: "44",
      fill: "#454545",
      class: "background",
      rx: "22"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M22.776 32.094c.453.388 1.1 0 1.1-.518v-7.894l-5.305 5.306 4.205 3.106ZM9.965 25.882h3.623v-7.764H9.965c-.453 0-.906.388-.906.905v6.018c0 .453.388.906.906.906v-.065ZM25.43 24.653l1.358 1.359a5.714 5.714 0 0 0 1.23-6.341l-1.553 1.553c.259 1.23-.13 2.523-1.036 3.494v-.065ZM29.053 28.277l1.359 1.358c3.753-3.752 4.206-9.576 1.359-13.847l-1.424 1.424c2.135 3.494 1.682 8.088-1.359 11.065h.065Z",
      class: "foreground"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m27.241 26.465 1.359 1.359c2.718-2.718 3.17-6.924 1.359-10.159l-1.424 1.424c1.165 2.394.712 5.37-1.294 7.376ZM23.941 20.059v-7.765c0-.582-.647-.906-1.1-.518L14.3 18.119v7.764l2.265 1.618-7.441 7.441h1.811l24.006-24.07V9.059l-11 11Z",
      class: "foreground"
    }, null, -1)
  ])))
}
export default { render: render }